import Page from "../page";

function FAQ() {
  return (
    <Page>
      <h1>Questions fréquentes (FAQ)</h1>
      <h2>Comment créer un album photo ?</h2>
      <p>Voici comment faire pour créer votre album :</p>
      <ul>
        <li>Vous connectez.</li>
        <li>Cliquer sur créer votre livre photo.</li>
        <li>Personnalisez la couverture de votre album (photo, couleur, thème, titre)​.</li>
      </ul>
      <p>Si vous êtes sur votre ordinateur</p>
      <ul>
        <li>Importer vos photos dans la photothèque.</li>
        <li>Glissez vos photos vers les pages de votre album.</li>
        <li>
          Modifier le format des pages en cliquant sur les petites flèches au dessus de chaque page.
        </li>
      </ul>
      <p>Si vous êtes sur votre smartphone</p>
      <ul>
        <li>Cliquer sur chaque page pour importer les photos</li>
        <li>
          Modifier les mises en page en cliquant sur les petites flèches au dessus de chaque page.
        </li>
      </ul>
      <p>
        Et voilà, il ne reste plus qu'à valider votre commande​, remplir le formulaire et attendre le
        ​livreur.
      </p>
      <h2>Est ce qu'on peut utiliser le site sur smartphone?</h2>
      <p>Le site est responsive, donc vous pouvez​ utiliser le site le plus normalement possible.</p>
      <p>
        La seule différence, nous avons supprimer la photothèque dans la version smartphone étant
        donné la petite surface disponible pour afficher l'interface.
      </p>
      <h2>Comment télécharger mes photos ?</h2>
      <p>Voici comment télécharger vos photos:</p>
      <ul>
        <li>
          Si vous êtes sur votre ordinateur, ​vous pourrez télécharger les photos provenant des
          dossiers de votre ordinateur.
        </li>
        <li>
          Si vous êtes sur votre smartphone ou tablette, vous pouvez télécharger vos photos
          provenant:
          <ul>
            <li>du stockage interne du téléphone​.</li>
            <li>Google photos si vous êtes sous android.</li>
          </ul>
        </li>
      </ul>
      <p>
        Une fonctionnalité permettant de télécharger les photos provenant de instagram ou facebook
        sera bientôt disponible ;)
      </p>
      <h2>Comment recadrer mes photos ?</h2>
      <p>Nous recadrons et recentrons les photos que vous envoyez de notre côté.</p>
      <h2>Combien de photos je peux mettre?</h2>
      <p>
        L'album de base contient 20 pages et chaque page peut contenir jusqu'à 4 photos donc il
        contient au minimum 20 photos et maximum 80.
      </p>
      <p>
        Mais si vous avez envie de mettre plus de photos ,vous pouvez à tout moment ajouter des
        pages supplémentaires à votre album.
      </p>
      <h2>Que signifie l'avertissement qualité ?</h2>
      <p>
        Nous ​avons mis​ un système qui permet de détecter les photos qui risquent de ne pas avoir un
        bon rendu suite à l'impression. Lorsqu'une photo est trop petite, ou avec une résolution
        trop faible, une icône d'avertissement s'affiche sur les photos​, il est préférable de ne pas
        l'utiliser.
      </p>
      <p>
        Si vous ignorez cet avertissement, vos photos risquent d'être floues sur le papier, même si
        sur l'écran vous avez l'impression qu'elles sont de bonne qualité.
      </p>
      <h2>Comment obtenir la meilleure qualité d'impression ?</h2>
      <p>
        Il y a des photos qui ne sont pas suffisamment de bonne qualité pour être imprimées
        correctement.
      </p>
      <p>
        La résolution d'une image est cruciale, ​éviter ​​​de prendre les photos téléchargées depuis les
        réseaux sociaux car généralement leur résolution est très basse. Si vous imprimez une image
        avec une résolution basse sur papier, elle peut avoir un aspect flou ou pixelisé.
      </p>
      <p>
        Nous vous conseillons d'imprimer uniquement des photos en haute résolution et de bien faire
        attention aux avertisseurs qualité qui s'affichent au cas où la photo a une résolution
        basse.
      </p>
      <h2>Puis-je utiliser des photos sombres ?</h2>
      <p>
        Il ​faut savoir qu'une ​photo imprimée sera toujours un peu plus sombre que lorsque vous la
        voyez sur un écran rétro-éclairé. ​L​es ​photos sombres le seront encore ​plus une fois
        imprimées.
      </p>
      <h2>Comment sauvegarder une création ?</h2>
      <p>
        Une fois que vous avez créé un album, votre album sera sauvegardé automatiquement à chaque
        modification.
      </p>
      <p>
        À votre prochaine connexion vous trouverez votre album au clic sur le bouton "Créer mon
        livre photo", vous pourrez finir votre création ou en commencer un autre.
      </p>
      <h2>Le prix de l'album?</h2>
      <p>
        le prix de l'album (20 pages) est de 2900 DA plus les frais de livraison. Le prix d'une page
        supplémentaire est de 250 DA de plus
      </p>
      <h2>Comment se fait le paiement?</h2>
      <p>Le paiement se fait directement à la livraison​.</p>
      <h2>Quels sont les délais de production et de livraison ?</h2>
      <p>
        Le temps de production​ (réalisation et impression) prend de 4 à 5 jours, et pour la
        livraison Il faut compter de 2 à 5 jours ouvrés (hors weekend et jours fériés)
      </p>
      <p>
        Donc au total il faut compter dans les environs de 10 jours ouvrés (hors weekend et jours
        fériés)
      </p>
      <h2>Suppression et modification de photos</h2>
      <p>Vous voulez supprimer une photo d'une page pour la modifier il n'y a pas plus simple​:</p>
      <ul>
        <li>
          - Si vous êtes sur votre ordinateur, il suffit de glisser déposer votre nouvelle photo sur
          la photo que vous voulez modifier elle sera automatiquement remplacée.
        </li>

        <li>
          - Si vous êtes sur un smartphone ou tablette, vous cliquer sur la photo que vous voulez
          modifier et vous refaite le processus de téléchargement pour avoir la nouvelle photo.
        </li>
      </ul>
      <p>
        Bientôt nous ajouterons la possibilité de supprimer les photos de votre photothèque. Pour le
        moment vous pouvez nous faire la demande et on le fera manuellement de notre côté.
      </p>
    </Page>
  );
}

export default FAQ;
